import tCourseDetail from './courseDetail'
import tQuizResult from './quizResult'

const courseDetail = {
  tCourseDetail,
  tQuizResult
}
export default courseDetail
